$(function() {
  var formChanged = false

  $('form[data-dirty]')
    .on('keyup change paste', 'input, select, textarea', function() {
      formChanged = true
    })
    .on('submit', function() {
      $(window).unbind('beforeunload')
    })

  $(window).on('beforeunload', function(e) {
    if (formChanged) {
      return 'Are you sure you want to leave this page without saving changes?'
    }
  })
})
